import {Component, forwardRef, Injector} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {AbstractMultiSelectEditControlComponent} from "./abstract-multi-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultiSelectEditControlComponent),
    multi: true
};

/**
 * Provides a multiple selection on a edit form. <wbo-select-options> is used to provide the options.
 */
@Component({
    selector: "wbo-multi-select-edit-control",
    templateUrl: "./multi-select-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class MultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);
    }
}
